import tippy ,{delegate} from 'tippy.js';

let howItWorks = document.getElementById('howItWorks')
let howItWorksContent = document.getElementById('howItWorksContent')
if (typeof(howItWorksContent) != 'undefined' && howItWorksContent != null) {
    tippy(howItWorks, {
        duration: 0,
        arrow: false,
        delay: [100, 100],
        trigger: 'click', // triggered by click on button
        touch: ['hold', 200], // long press 500ms delay
        placement: 'left-start',
        content(reference) {
            const id = reference.getAttribute('data-template');
            const template = document.getElementById(id);
            return template != null ? template.innerHTML : '';
        },
        theme: 'rcodezero',
        allowHTML: true, // can contain HTML.
        interactive: true, // allowing you to hover over and click inside it.
        appendTo: () => document.body, // necessary for displaying in correct width!!
        maxWidth: 600,
        zIndex: 9000
    });

    delegate(howItWorks, {
        target(reference) {
            const id = reference.getAttribute('data-template');
            return document.getElementById(id);
        }
    });
} else {
	if(typeof(howItWorks) !== 'undefined' && howItWorks !== null)
        howItWorks.style.display = 'none';
}
tippy('#recordsTypeHint', {
    content: trans({
        en: "You can also use a custom record type by writing: TYPEXXX. E.g. (A): TYPE1",
        de: "Sie können auch einen benutzerdefinierten Typ verwenden, indem Sie schreiben: TYPEXXX. Z.B. wäre 'TYPE1' ein A record.",
    }),
});

tippy('#zoneListSearchTypeHint', {
    content: "Filters:<br>- ^ matches the begin of the domainname<br>- $ matches the end of the domainname<br>(e.g. .at$: get a list of domains with the TLD .at)",
    allowHTML: true,
});
tippy('#recordsListSearchTypeHint', {
    content: "Filters (name and content):<br>- ^ matches the begin of the value <br>- $ matches the end of the value<br>(e.g. '^mail.': get a list of records starting with 'mail.')",
    allowHTML: true,
});
